import { makeStyles } from '../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        height: '40px',
        backgroundColor: theme.colors.gray[100],
        '& .MuiTableCell-root': Object.assign(Object.assign({}, theme.typography.label), { color: theme.colors.gray[700] }),
    },
}));
//# sourceMappingURL=TableHead.styles.js.map